(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('[data-zoom]');
    const photo = stage.querySelector('img');
    const dialog = root.querySelector('dialog');
    const enlarged = dialog.querySelector('img');
    root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
      photo.removeAttribute('srcset');
      photo.src = button.dataset.photo;
      photo.alt = button.dataset.alt;
      stage.href = button.dataset.photo;
      enlarged.src = button.dataset.photo;
      enlarged.alt = button.dataset.alt;
      root.querySelector('[data-caption-output]').textContent = button.dataset.caption;
      root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    stage.addEventListener('click', event => {
      if (!dialog.showModal) return;
      event.preventDefault();
      dialog.showModal();
    });
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => stage.focus());
    const quantity = root.querySelector('[name="quantity"]');
    const form = root.querySelector('.sereni-form');
    const add = form.querySelector('[name="add"]');
    const sticky = root.querySelector('.sereni-sticky');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const addLabel = add.textContent;
    const available = !add.disabled;
    let submitting = false;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: root.dataset.currency, currencyDisplay: 'code'
    });
    function syncQuantity() {
      const valid = quantity.validity.valid && Number(quantity.value) > 0;
      const sets = Number(quantity.value);
      const label = valid ? `${sets} ${sets === 1 ? 'set' : 'sets'} / ${sets * 2} chairs` : 'Enter a valid quantity';
      root.querySelector('[data-order-summary]').textContent = label;
      root.querySelector('[data-sticky-quantity]').textContent = label;
      root.querySelector('[data-sticky-total]').textContent = valid ? money.format(Number(root.dataset.price) * sets / 100) : '';
      stickyAdd.disabled = !available || submitting;
      stickyAdd.textContent = available && !valid ? 'Choose quantity' : add.textContent;
    }
    quantity.addEventListener('input', syncQuantity);
    quantity.addEventListener('change', syncQuantity);
    root.querySelector('[data-edit-quantity]').addEventListener('click', event => {
      event.preventDefault();
      quantity.scrollIntoView({block: 'center'});
      quantity.focus({preventScroll: true});
    });
    // Use the original button so theme click tracking and native form validation still run.
    stickyAdd.addEventListener('click', () => {
      if (!quantity.validity.valid) {
        quantity.scrollIntoView({block: 'center'});
        quantity.reportValidity();
        return;
      }
      if (!submitting) add.click();
    });
    form.addEventListener('submit', event => {
      if (submitting) { event.preventDefault(); return; }
      if (event.defaultPrevented) return;
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      add.textContent = 'Adding...';
      stickyAdd.textContent = 'Adding...';
      stickyAdd.disabled = true;
      // Keep the native submitter enabled while the browser constructs the request.
    });
    window.addEventListener('pageshow', () => {
      submitting = false;
      form.removeAttribute('aria-busy');
      add.textContent = addLabel;
      syncQuantity();
    });
    let frame = 0;
    function syncSticky() {
      frame = 0;
      const footer = document.querySelector('footer');
      sticky.hidden = add.getBoundingClientRect().bottom >= 0 || Boolean(dialog.open) ||
        Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight);
    }
    function scheduleSticky() {
      if (!frame) frame = requestAnimationFrame(syncSticky);
    }
    window.addEventListener('scroll', scheduleSticky, {passive: true});
    window.addEventListener('resize', scheduleSticky, {passive: true});
    dialog.addEventListener('close', scheduleSticky);
    stage.addEventListener('click', scheduleSticky);
    syncQuantity();
    syncSticky();
    // Read the current provider-rendered aggregate; never freeze a rating or review count in copy.
    const reviewLink = root.querySelector('[data-review-link]');
    function syncReviews() {
      const reviews = document.querySelector('.yotpo-widget-clear[aria-label="Customer Reviews"]');
      const score = reviews?.querySelector('.yotpo-bottom-line-score')?.textContent.trim();
      const count = reviews?.querySelector('.yotpo-bottom-line-basic-text')?.textContent.trim();
      if (!score || !count) return false;
      reviewLink.textContent = `${score}/5 - ${count} - photos`;
      return true;
    }
    if (!syncReviews()) {
      const reviewObserver = new MutationObserver(() => { if (syncReviews()) reviewObserver.disconnect(); });
      reviewObserver.observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
      window.setTimeout(() => reviewObserver.disconnect(), 30000);
    }
    root.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.step === '1') quantity.stepUp(); else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    root.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-in]').forEach(cell => { cell.textContent = cell.dataset[button.dataset.unit] + ' ' + button.dataset.unit; });
      root.querySelectorAll('[data-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
  }
  document.querySelectorAll('.sereni').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sereni').forEach(init));
})();
